import { motion } from 'framer-motion';
import React from 'react';
import { buttonMotion } from '@/animations';

// Props Types
export interface PressedMotionProps {
	children: React.ReactNode;
	fullWidth?: boolean;
	pressPower?: number;
	className?: string;
}

export const PressedMotion: React.FC<PressedMotionProps> = ({
	children,
	fullWidth,
	pressPower = 0.98,
	className,
}) => {
	return (
		<motion.div
			className={className}
			// Animation
			{...buttonMotion}
			custom={pressPower}
			tabIndex={-1}
			style={{
				width: fullWidth ? '100%' : 'auto',
			}}
		>
			{children}
		</motion.div>
	);
};
